module.exports = __webpack_public_path__ + "static/media/plane.74e50406.png";